import React from "react"
import ModalV4 from "../../../../app/ui/modal/v4/v4"

import TaskFinder from '../../../../core/gd-components/finder/task/task-finder'
import Task from "../../../model2/task/task"

type Props = {
    params: {
        projectId           : ID
        excludedTasksIds    : ID[]

        onSubmit            : {(item:any):void}
    }
}

export default class ModalTaskLink extends ModalV4 {

    onClickTask = (task: Task) => {
        if (this.props.params.onSubmit) this.props.params.onSubmit({id: task.id, name: task.title, type: 'task', data:task})
    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <TaskFinder parentProjectId     = {this.props.params.projectId}
                            excludedTasksIds    = {this.props.params.excludedTasksIds}
                            onClickTask         = {this.onClickTask}
                            onClose             = {this.closeModal}/>
            </div>
        );
    }
}